import {
  Share2, Camera, Sparkles, Plane, Target, Clapperboard,
  ShieldCheck, Award, Lock, Infinity, TrendingUp, Zap,
} from "lucide-react";

const MAP = {
  Share2, Camera, Sparkles, Plane, Target, Clapperboard,
  ShieldCheck, Award, Lock, Infinity, TrendingUp, Zap,
};

export function Icon({ name, className }) {
  const C = MAP[name] || Sparkles;
  return <C className={className} />;
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-cobalt-300 ${className}`}>
      <span className="w-6 h-px bg-neon-magenta" />
      {children}
    </span>
  );
}
